import React from 'react';
import StatusBadge from './StatusBadge';
import { formatCurrency, formatDateTime } from '../../utils/invoiceFormatters';

const JobResultTable = ({ details, loading }) => {
  if (loading) {
    return (
      <div className="space-y-2">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-10 bg-gray-100 rounded animate-pulse" />
        ))}
      </div>
    );
  }

  if (!details || details.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400 text-sm">
        No enterprise results yet.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-xs text-gray-400 uppercase bg-gray-50">
            <th className="text-left px-4 py-3 font-medium">Enterprise</th>
            <th className="text-center px-4 py-3 font-medium">Status</th>
            <th className="text-left px-4 py-3 font-medium">Billing #</th>
            <th className="text-right px-4 py-3 font-medium">Total</th>
            <th className="text-left px-4 py-3 font-medium">Note</th>
            <th className="text-right px-4 py-3 font-medium">Processed At</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {details.map((d) => (
            <tr key={d.id} className="hover:bg-gray-50">
              <td className="px-4 py-3 font-medium text-gray-800">{d.enterpriseName}</td>
              <td className="px-4 py-3 text-center">
                <StatusBadge status={d.status} />
              </td>
              <td className="px-4 py-3 font-mono text-xs text-gray-500">
                {d.invoiceNumber || '-'}
              </td>
              <td className="px-4 py-3 text-right text-gray-700">
                {d.totalAmount != null ? formatCurrency(d.totalAmount) : '-'}
              </td>
              <td className="px-4 py-3 max-w-[220px]">
                {d.status === 'FAILED' && d.errorMessage ? (
                  <span
                    className="text-xs text-red-600 truncate block cursor-help"
                    title={d.errorMessage}>
                    {d.errorMessage.length > 60
                      ? d.errorMessage.substring(0, 60) + '...'
                      : d.errorMessage}
                  </span>
                ) : d.skipReason ? (
                  <span className="text-xs text-gray-400">{d.skipReason}</span>
                ) : (
                  <span className="text-xs text-gray-300">-</span>
                )}
              </td>
              <td className="px-4 py-3 text-right text-xs text-gray-400">
                {formatDateTime(d.processedAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JobResultTable;
